export default __webpack_public_path__ + "images/models/b55ad091cc234e38174db27e82876bbc.usdz";